import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=5d54d50a&scoped=true"
import script from "./SendNotification.vue?vue&type=script&lang=js"
export * from "./SendNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d54d50a",
  null
  
)

export default component.exports